/** DEMO-ONLY: SKU → sale price for mutable mock basket lines. Auto-derived from products/get.json. */
export const PRESIDIO_MOCK_PRODUCT_PRICES: Record<string, number> = {
  '1250g': 129,
  '32UN880': 699,
  '3R02047': 59,
  '4001dn': 449,
  '4301fdw': 799,
  '45-248-026': 249,
  '7000E': 299,
  '747': 39,
  '75UR640S': 1299,
  'A7516': 45,
  'AMD-MI300X': 186000,
  'AMD-MI325X': 212000,
  'AP8858': 899,
  'ATA191': 129,
  'BDL-AI-LAB': 118000,
  'BDL-CLOUD': 84000,
  'BDL-EDGE': 29500,
  'BDL-SEC': 50500,
  'BRIO-4K': 179,
  'C210E': 349,
  'C9200-48P': 5980,
  'C9300L-48P': 5350,
  'C9400-Chassis': 39500,
  'C9500-48Y4C': 26200,
  'CCS-720XP': 8250,
  'CISCO-C9300': 8900,
  'CL-15': 59,
  'CP-8841': 279,
  'CP-8865': 449,
  'CS-KIT-MINI': 3499,
  'CSF-3105': 22800,
  'DCS-7050X3': 17200,
  'DCS-7130': 24800,
  'DCS-7280R3': 29800,
  'DCS-7800R3': 89000,
  'DDN-AI200': 91500,
  'DDN-AI400X2': 142000,
  'DDN-EXA9': 198000,
  'DDN-IME': 136000,
  'DDN-SFA18K': 154000,
  'DEF-UNI': 49,
  'DELL-ECS-EX300': 82000,
  'DELL-MX760C': 13500,
  'DELL-PMAX2500': 174000,
  'DELL-PSTORE500': 72500,
  'DELL-R660': 9200,
  'DELL-R750': 9450,
  'DELL-R760XA': 17200,
  'DELL-SC5020': 41500,
  'DELL-T550': 4990,
  'DELL-XE8640': 134000,
  'DELL-XE9680': 241000,
  'DELL-XR11': 7350,
  'DELL-XR4000': 14600,
  'DS-1630': 299,
  'E24-G5': 189,
  'ED800-G9': 1099,
  'EV2-85': 299,
  'EX4400-48MP': 7200,
  'EX4650-48Y': 13400,
  'FAC-300F': 4990,
  'FAZ-300F': 8250,
  'FG-100F': 2950,
  'FG-600F': 17200,
  'FOCUS2': 249,
  'FPR-2130': 15500,
  'FTNT-SASE-B': 6950,
  'FW-86BZ30L': 3499,
  'GA04815': 699,
  'HPE-ALL-6050': 91500,
  'HPE-C7000': 29800,
  'HPE-DL360-G11': 8300,
  'HPE-DL380-PERF': 15600,
  'HPE-DL560-G11': 22800,
  'HPE-EL8000': 17800,
  'HPE-ML350-G11': 5650,
  'HPE-NIM-HF20': 54000,
  'HPE-PRIM-A650': 133000,
  'HPE-RL300': 6350,
  'HPE-SO-3660': 33500,
  'IE-3400': 2950,
  'IFP4320': 1499,
  'IPHONE15-128': 799,
  'IPHONE15P-256': 1099,
  'ISE-3695': 26200,
  'ISR4331-V': 3499,
  'J9772A': 1090,
  'JL624A': 18100,
  'JL661A': 6650,
  'LAT-5540': 1499,
  'LAT-7440': 1899,
  'LEN-SE450': 9100,
  'LEN-SE70': 2950,
  'LEN-SR630-V3': 8000,
  'LEN-SR650-V3': 10400,
  'LEN-SR850-V3': 25900,
  'LSM1U': 189,
  'LW-550': 149,
  'M800': 2899,
  'MDM-KIT': 99,
  'MFC-L5900DW': 549,
  'MK2D3': 129,
  'MW632ST': 799,
  'MX-KEYS': 119,
  'MX3S': 99,
  'MZ-V8P2T0': 189,
  'N9K-C9336C': 20500,
  'N9K-C9364D': 64000,
  'NTAP-A250': 48500,
  'NTAP-A400': 105000,
  'NTAP-A700': 119000,
  'NTAP-A800': 186000,
  'NTAP-CVO': 16500,
  'NTAP-FAS2750': 44500,
  'NTAP-ONTAP-AI': 62500,
  'NTAP-SG': 59500,
  'NV-6000-ADA': 8400,
  'NV-A40': 6800,
  'NV-A6000': 6250,
  'NV-B100': 45500,
  'NV-DGX-A100': 175000,
  'NV-DGX-B200': 499000,
  'NV-DGX-GB200': 399000,
  'NV-DGX-H100': 210000,
  'NV-DGX-STN': 74500,
  'NV-H100-PCIE': 29800,
  'NV-H200-PCIE': 38500,
  'NV-HGX-B200': 342000,
  'NV-HGX-H100': 295000,
  'NV-HGX-H200': 285000,
  'NV-L4-24G': 9200,
  'NV-L40-48G': 39500,
  'NV-L40S-24': 68400,
  'NV-L40S-24-1U-3Y': 68400,
  'NV-L40S-24-1U-5Y': 73200,
  'NV-L40S-24-2U-3Y': 71600,
  'NV-L40S-24-2U-5Y': 76400,
  'NV-L40S-48': 82400,
  'NV-L40S-48-1U-3Y': 82400,
  'NV-L40S-48-1U-5Y': 87200,
  'NV-L40S-48-2U-3Y': 85600,
  'NV-L40S-48-2U-5Y': 90400,
  'NV-L40S-48G': 72400,
  'NV-L40S-CFG': 72400,
  'OPTI-7010': 899,
  'PA-3220': 20500,
  'PA-5450': 89000,
  'PAN-M-100': 12900,
  'PAN-PRISMA-K': 13900,
  'PL-4K': 2499,
  'PRS-AI-STARTER': 450000,
  'PRS-API-SEC': 9050,
  'PRS-ARCH-1': 16900,
  'PRS-ARCH-DISK': 24200,
  'PRS-BARE-1': 8200,
  'PRS-BKP-100': 29500,
  'PRS-CORE-100': 22800,
  'PRS-CRYPT-GW': 14800,
  'PRS-CTRL-3': 18500,
  'PRS-DELL-R760': 16200,
  'PRS-DNS-SEC': 3850,
  'PRS-EDGE-AP': 890,
  'PRS-EDGE-FW': 5400,
  'PRS-EDGE-INF': 11200,
  'PRS-EDGE-MINI': 1890,
  'PRS-EDGE-SW': 3200,
  'PRS-EMAIL-SEC': 5150,
  'PRS-FAB-KIT': 45000,
  'PRS-FC-KIT': 13200,
  'PRS-FTNT-FG': 12400,
  'PRS-GDS-1': 110000,
  'PRS-GPU-W1': 26500,
  'PRS-HCI-3': 39500,
  'PRS-HPE-DL380': 14800,
  'PRS-HYB-20': 16900,
  'PRS-HYB-80': 38900,
  'PRS-IDP-1': 11000,
  'PRS-IDS-1': 6650,
  'PRS-IND-8': 1320,
  'PRS-K8S-N1': 6700,
  'PRS-LAB-STOR': 22500,
  'PRS-LAB-STOR2': 8900,
  'PRS-LEAF-25': 11800,
  'PRS-META-1': 26800,
  'PRS-MG-24': 3150,
  'PRS-MOUSE-OPT': 29.99,
  'PRS-MSEG-1': 12500,
  'PRS-NAC-1': 9100,
  'PRS-NAS-48': 22600,
  'PRS-NFS-GW': 19800,
  'PRS-NVME-100': 89000,
  'PRS-OBJ-200': 72500,
  'PRS-OBJ-50': 25500,
  'PRS-OMNI-WS': 22900,
  'PRS-OOB-24': 890,
  'PRS-OT-SEC': 15200,
  'PRS-POE-48': 1890,
  'PRS-PURE-X20': 95000,
  'PRS-RAG-1': 52000,
  'PRS-REPL-1': 19200,
  'PRS-S3-GW': 11200,
  'PRS-SAN-ISCSI': 18200,
  'PRS-SASE-1': 8200,
  'PRS-SMB-1': 14900,
  'PRS-SOC-SENS': 10200,
  'PRS-SPINE-400': 68000,
  'PRS-STUDIO': 15400,
  'PRS-SVC-AI-ASSESS': 25000,
  'PRS-SVC-DEPLOY': 75000,
  'PRS-T2-BUF': 33200,
  'PRS-TRN-POD4': 845000,
  'PRS-VEEAM-R': 25800,
  'PRS-VPN-C': 5980,
  'PRS-WAF-1': 7200,
  'PRS-WIFI-SW': 3780,
  'PS-16C': 249,
  'PSU-1600T': 429,
  'PURE-CBR': 40000,
  'PURE-CBS-LIC': 20500,
  'PURE-FAC': 89000,
  'PURE-FAX': 124000,
  'PURE-FAXL': 198000,
  'PURE-FB': 145000,
  'PURE-FBE': 84000,
  'PURE-FBX': 165000,
  'PURE-PX-ESS': 13800,
  'PX3-5490V': 1299,
  'Q1': 169,
  'QFX10002-72Q': 51500,
  'QFX5120-48Y': 15200,
  'QN65Q60C': 899,
  'R8S96A': 35500,
  'RALLY-CAM': 999,
  'S34C650': 599,
  'SATURN3I': 129,
  'SM-G736': 649,
  'SM-S921': 849,
  'SMCI-1U-GPU': 17200,
  'SMCI-221H': 12500,
  'SMCI-4L40S': 92500,
  'SMCI-4U-SDS': 11000,
  'SMCI-EDGE-1': 5750,
  'SMCI-HGX-8H100': 265000,
  'SMT1500': 649,
  'SMT3000': 1499,
  'SMX120BP': 799,
  'SPEAK750': 229,
  'STU-540': 449,
  'STUDIO-X50': 2799,
  'SUPPORT-3YR': 20500,
  'SVC-BKP-OPS': 4800,
  'SVC-DR': 14000,
  'SVC-FINOPS': 9500,
  'SVC-FTE': 18000,
  'SVC-FW': 22000,
  'SVC-GPU-OPS': 22000,
  'SVC-HEALTH': 5500,
  'SVC-HYPER': 9800,
  'SVC-IAC': 24000,
  'SVC-K8S': 45000,
  'SVC-NOC': 12000,
  'SVC-OPS-MO': 8500,
  'SVC-PATCH': 6500,
  'SVC-STOR': 28000,
  'SVC-TRAIN': 7500,
  'SVC-WLAN': 8500,
  'SVC-ZT-DES': 16000,
  'T14-G5': 1649,
  'T630-24': 1299,
  'TR-STD': 180,
  'TS4': 379,
  'U2723QE': 549,
  'U4924DW': 1299,
  'UMB-SIG-KIT': 6300,
  'UN55CU7000': 499,
  'USB4-08': 39,
  'VAST-AI-STOR': 185000,
  'VAST-CBOX': 118000,
  'VAST-DNODE': 92000,
  'VAST-SNAP': 50500,
  'VVX-450': 229,
  'W2020A': 89,
  'W2021-23A': 249,
  'WD19S': 249,
  'WEKA-EDGE': 39000,
  'WEKA-NODE': 71000,
  'WEKA-SCALE': 57500,
  'ZBOOK-F16': 2799,
  'ZD421': 349,
  'fi-8170': 1199,
};
